import React from "react";
import { Col, Container } from "react-bootstrap";
import whatsapp from "../../assets/images/whatsapp.svg";
import telegram from "../../assets/images/telegram.svg";
import instagram from "../../assets/images/instagram.svg";
import logo from "../../assets/images/logo.png";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Header = ({faq}) => {

    const goToViolation = (id) => {
        const violation = document.getElementById(id);
        var root = document.getElementById("root");
        root.scrollTo({
            top: violation.offsetTop,
            behavior: "smooth"
        });
    };
    const history = useHistory();
    return (
        <header>
            <Container className="sm d-flex my-header radius-b shadow-sm">
                <Col className="d-flex me-4 d-none d-md-flex d-lg-flex d-xl-flex">
                    <div className="my-font logo"><img style={{ maxHeight: "3rem", maxWidth: "3rem" }} src={logo}></img></div>
                    <span className="my-font me-3">|</span>
                    <p className="me-3 ">نسل فردا</p>
                </Col>
                <Col className="d-flex mid-col justify-content-center d-none d-md-flex d-lg-flex d-xl-flex">
                    <p style={{ cursor: "pointer" }} className="px-4 change-font head-links" onClick={() => window.open('http://www.naslefarda.net/')}>خانه</p>
                    {faq === false ? (
                        <>
                            <p style={{ cursor: "pointer" }} className="px-4 change-font head-links" onClick={() => goToViolation("products")}>امکانات</p>
                            <p style={{ cursor: "pointer" }} className="px-4 change-font head-links" onClick={() => goToViolation("whyUs")}>چرا ما ؟</p>
                            <p style={{ cursor: "pointer" }} className="px-4 change-font head-links" onClick={() => goToViolation("ContactUs")}>ارتباط با ما</p>
                            <p style={{ cursor: "pointer" }} className="px-4 change-font head-links" onClick={() => history.push("/faq")}>قوانین و مقررات سایت</p>
                        </>
                    ): (
                        <p style={{ cursor: "pointer" }} className="px-4 change-font head-links" onClick={() => history.push("/")}>بازگشت</p>
                   )}
                </Col>
                <Col className="d-flex justify-content-end ms-4 d-none d-md-flex d-lg-flex d-xl-flex">
                    <img style={{ cursor: "pointer" }} className="nav-icon mx-3" src={whatsapp} alt="" onClick={() => window.open('https://web.whatsapp.com/send?phone=989301638346&text=')} />
                    <img style={{ cursor: "pointer" }} className="nav-icon mx-3" src={telegram} alt="" onClick={() => window.open('https://telegram.me/agahinaslefarda')} />
                    <img style={{ cursor: "pointer" }} className="nav-icon me-3" src={instagram} alt="" onClick={() => window.open('https://www.instagram.com/naslefardanews/')} />
                </Col>
                <div className="mob-header mt-3">
                    <div className="my-font-2 me-4 ">...</div>
                    <div className="my-font-2 ms-4 "><img style={{ maxHeight: "3rem", maxWidth: "3rem" }} src={logo}></img></div>
                </div>
            </Container>
        </header>
    );
};

export default Header;
